import CrudActionSetBase from './CrudActionSetBase'

export class VersionActionSet extends CrudActionSetBase('version'){
}

export default new VersionActionSet()